
    import './styles.scoped.css';
    export default {
  "slider": "awsui_slider_cqzlk_rmf4q_9",
  "slider-side": "awsui_slider-side_cqzlk_rmf4q_43",
  "slider-side-start": "awsui_slider-side-start_cqzlk_rmf4q_44"
};
  